import {IPlayer} from "../player/types";
import {IApiResponse} from "../../shared/utils/apiCall";
import {ISettingsState} from "../settings/types";
import {Language} from "../settings/Language";
import {IApplicationState} from "../index";

export const REQUEST_POSTFIX = 'REQUEST';
export const SUCCESS_POSTFIX = 'SUCCESS';
export const FAILURE_POSTFIX = 'FAILURE';

export type ErrorResponse = {
    message: string
}

export interface IHandshake extends IPlayer {
    readonly locale: string | null;
    readonly entryPoint: ISharedEntryPoint | null;
    readonly version: string;
    readonly platform: string | null;
}

export interface ISharedEntryPoint {
    readonly questionId?: number;
    readonly tracking?: ITracking;
}

export interface IHandshakeResponse extends IApiResponse {
    data: {
        clientSettings?: Partial<ISettingsState>;
        clientData?: Partial<IApplicationState>;
        language: Language;
        userId?: number;
        allowDebug?: boolean;
        localization: ILocalizationSnapshot;
    }
}

export interface ILocalizationSnapshot {
    version: number;
    items: Record<string, string>;
}

export interface IReport {
    name: string;
    email: string;
    text: string;
}

export interface ITracking {
    utm_medium: string;
    utm_source: string;
    utm_campaign: string;
    utm_term: string;
    utm_content: string;
    utm_list: string;
}

export const loadingMatcher = new RegExp(`(.*)_(${REQUEST_POSTFIX}|${SUCCESS_POSTFIX}|${FAILURE_POSTFIX})`);
export const errorMatcher = new RegExp(`(.*)_(${REQUEST_POSTFIX}|${FAILURE_POSTFIX})`);

export type StoreVendor = 'apple' | 'google' | 'huawei';